export const ssprefix = "spapply_";

export const endpoint = "https://pannello.educo.distrettoalpiorientali.it/api.php?token=18t8ec81f132b224e5cdaf2f161fa5253bf34218bec2a86dac7f128921f6d3ea8b4";